import {
  loginApi,
  createUser,
  loginWithPwd,
  getTenantConfig,
  verifyOtp,
  verifyEmailOtp,
  forgotPassword,
  resetPassword,
} from "./auth.services";
const userInfo = JSON.parse(
  localStorage.getItem(`${process.env.VUE_APP_TENANT}:userInfo`),
);
const token = localStorage.getItem(
  `${process.env.VUE_APP_TENANT}:access_token`,
);
export default {
  namespaced: true,
  state: {
    token: "",
    userInfo: userInfo ? userInfo : {},
    isLoggedin: token ? true : false,
  },
  mutations: {
    loginToken(state, payload) {
      state.token = payload;
    },
    setUserData(state, payload) {
      state.isLoggedin = true;
      state.userInfo = payload;
    },
    resetUser(state) {
      state.isLoggedin = false;
      state.userInfo = {};
      state.token = "";
    },
  },
  actions: {
    async verifyEmailOtp(context, payload) {
      let res = await verifyEmailOtp(payload);
      return res;
    },
    async forgotPasswordAction(context, payload) {
      let res = await forgotPassword(payload);
      return res;
    },
    async resetPasswordAction(context, payload) {
      let res = await resetPassword(payload);
      return res;
    },
    async verifyOtp(context, payload) {
      let res = await verifyOtp(payload);
      return res;
    },
    async createNewUser(context, payload) {
      let res = await createUser(payload);
      return res;
    },

    async getTenantConfigDetails() {
      let res = await getTenantConfig();
      return res;
    },

    async loginWithPassword(context, payload) {
      let res = await loginWithPwd(payload);
      return res;
    },

    loginToken: (context, payload) => {
      context.commit("loginToken", payload);
    },
    setUserData: (context, payload) => {
      context.commit("setUserData", payload);
    },
    resetUser: (context) => {
      context.commit("resetUser");
    },
    async callLogin(context, payload) {
      try {
        let res = await loginApi(payload);
        return res;
      } catch (err) {
        return err;
      }
    },
  },
};
